app.controller(
    'PlaceListController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'PlaceService', '$sce', '$translate', '$state', 'SideBarService', '$window', 'AdminService', 'HelperService', 'filterFilter', PlaceListController]
);


function PlaceListController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, PlaceService, $sce, $translate, $state, SideBarService, $window, AdminService, HelperService, filterFilter) {
    var vm = this;
    vm.isAllSelected = false;
    $scope.$parent.type = 'place';
    $translate.use($rootScope.LangForInterface);
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    if ($stateParams.mcd) {
        vm.ParamMcd = $stateParams.mcd;
    }
    else {
        vm.ParamMcd = 'all';
    }
   

    $rootScope.UpdateRoles();

    vm.PlaceList = []; //declare an empty array
   
    if ($stateParams.pageno == null)
        vm.pageno = 1;
    vm.total_count = 0;
    vm.sortKey = "PlaceTitle";
    vm.direction = "ascending";
    vm.reverse = false;
    vm.SearchVM = {};
    vm.SearchVM.slider =
         [{
             min: 0,
             max: 1000,
             options: {
                 floor: 0,
                 ceil: 1000,
                 translate: function (value) {
                     return value + '€';
                 },
                 hideLimitLabels: true
             }
         }, {
             min: 0,
             max: 24,
             options: {
                 floor: 0,
                 ceil: 24,
                 translate: function (value) {
                     return value + 'h';
                 },
                 hideLimitLabels: true
             }
         }]
    ;
    vm.SearchVM.ZoneTeam = {
        ResponsableEditionFRList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        ResponsableEditionENList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        AuthorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        TranslatorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        CorrectorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]

    };
    $rootScope.TopBarAction = {};
    $rootScope.TopBarAction.isActive = false;
    $rootScope.BatchReplaceTextResult = null;    
    vm.itemsPerPage = 10; //this could be a dynamic value from a drop down
    //todo search
    //replace this methode by getting params directly from the url 
    vm.getsearchurlparam = function (zoneId, mcd, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        if (SearchVM.Reset) {
            vm.SearchParam = "";
        }
        else {
            vm.SearchParam = HelperService.GetSearchUrlParam(SearchVM);
        }
        SearchVM.Reset = false;
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/list/place?z=' + zoneId + '&mcd=' + mcd + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + vm.SearchParam;
    };

       vm.getDataV2 = function () { // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.PlaceList = [];
      
        if ($stateParams.z != null)
            vm.ParamZoneId = $stateParams.z;

        if ($stateParams.pageno != null)
            vm.pageno = $stateParams.pageno;

        if ($stateParams.reverse != null)
            vm.reverse = $stateParams.reverse;

        if ($stateParams.sortkey != null)
            vm.sortKey = $stateParams.sortkey;

        if ($stateParams.istopbaractive != null)
            $rootScope.TopBarAction.isActive = $stateParams.istopbaractive;

        if ($rootScope.TopBarAction.isActive == 'true')
            $scope.showDetail('rechercher');
        else
            $scope.closeDetail('rechercher');

        if ($stateParams.searchText != null)
            $rootScope.TopBarAction.SearchText = $stateParams.searchText;
        else
            $rootScope.TopBarAction.SearchText = "";

        if ($stateParams.mcd != null) {
            vm.ParamMcd = $stateParams.mcd;
        }

        //Get List 
        var promiseGetList = PlaceService.GetPlaceList(vm.ParamZoneId, vm.ParamMcd, vm.itemsPerPage, vm.pageno, vm.sortKey, vm.reverse, $rootScope.LangForWork, $rootScope.TopBarAction.isActive, $stateParams.search, $stateParams.gsearch, $stateParams.searchText, vm.SearchVM);
        promiseGetList.then(function (response) {
            vm.PlaceList = response.data.PlaceList;
            // data to be displayed on current page.
            $rootScope.InitListSelectedId(vm.PlaceList, 'place', vm);
            vm.total_count = response.data.total_count; // total data count.
            $rootScope.total_count = response.data.total_count;
            vm.SearchVM = response.data.SearchVM;
            $rootScope.SideBarSearchVM = vm.SearchVM;
            //$scope.ChangeZoneById(vm.ParamZoneId);
            $rootScope.TopBarAction.StatusList = $rootScope.StatusList4WorkflowObject;
            $rootScope.TopBarAction.ClientList = angular.copy(vm.SearchVM.Client);
        });
    };
    vm.getData = function (zoneId, mcd, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/list/place?z=' + zoneId + '&mcd=' + mcd + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + '&search=' + $stateParams.search + '&gsearch=' + $stateParams.gsearch;
    };
    vm.getDataV2();

    $scope.$parent.search = $stateParams.search;
    $scope.$parent.gsearch = $stateParams.gsearch;
    $scope.$parent.mcd = vm.ParamMcd;
    $scope.$parent.sortkey = vm.sortKey;
    $scope.$parent.reversesort = vm.reverse;



    //  $scope.vm = vm;
    $rootScope.slider = [{
        min: 0,
        max: 1000,
        options: {
            floor: 0,
            ceil: 1000,
            translate: function (value) {
                return value + '€';
            },
            hideLimitLabels: true
        }
    }, {
        min: 0,
        max: 23,
        options: {
            floor: 0,
            ceil: 23,
            translate: function (value) {
                return value + 'h';
            },
            hideLimitLabels: true
        }
    }];



    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.ParamZoneId, vm.ParamMcd, vm.pageno, keyname, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, vm.SearchVM);
    }

    vm.getUserUrl = function (placeId, lang, index, sortKey, reverse, filter, itemZoneId) {
        var urlDynamique = '/#!/consultation/view?id=';
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Author) {
            urlDynamique = "/#!/consultation/view?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Corrector) {
            urlDynamique = "/#!/correction/place?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Translator) {
            urlDynamique = "/#!/traduction/place?lang2=" + $rootScope.LangForTranslationDestination + "&id=";
        }
        return $rootScope.interfaceSubFolder + urlDynamique + placeId + "&lang=" + lang + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse + "&z=" + itemZoneId;
    }

    $rootScope.AdvancedSearch = function AdvancedSearch() {
        $rootScope.resetSelectedListId();
        $rootScope.TopBarAction.isActive = false;

        vm.getsearchurlparam(vm.ParamZoneId, vm.ParamMcd, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    };

    $rootScope.GlobalAdvancedSearch = function GlobalAdvancedSearch(key, value) {
        if (value != null) {
            $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key] = value;
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = "";
            $rootScope.AdvancedSearch();
        }
    };

    $rootScope.removeTags = function (key) {
        //$rootScope.SideBarSearchVM.GlobalSearch.SearchValues.splice(key, 1);
        delete $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key];
        $rootScope.AdvancedSearch();
        //$rootScope.$apply();
    };


    $rootScope.ShowResultBeforeReplace = function () {        
        $rootScope.TopBarAction.isActive = true;        
        vm.getData(vm.ParamZoneId, vm.ParamMcd, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    }

    $rootScope.BatchReplaceText = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.PlaceList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Place;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;
        if ($rootScope.TopBarAction.IdList.length > 0 && $rootScope.TopBarAction.SearchText != undefined && $rootScope.TopBarAction.ToReplaceText != undefined) {
            SideBarService.BatchReplaceText($rootScope.TopBarAction)
            .then(
                    function success(data) {
                    },
                    function error(data) { });
        }
    }

    $rootScope.BatchModifyClient = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.PlaceList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Place;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyClient($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    $rootScope.BatchModifyStatus = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.PlaceList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Place;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyStatus($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    $rootScope.SendAllVerificationEmailOfOneZone = function () {
        SideBarService.SendAllVerificationEmailOfOneZone(vm.ParamZoneId, $rootScope.EnumLinkType.Place)
            .then(
                function success(data) {
                    toastr.success($translate.instant("EnvoyerEmailVerificationNotification"));
                },
                function error(data) {
                    toastr.error($translate.instant("errorMessage"));
                });
    }    

    $rootScope.LastVerificationEmailSendingDateOfGuide = "NA";  

    $rootScope.GetLastSendingTimeOfVerificationEmailOfZone = function () {
        SideBarService.GetLastSendingTimeOfVerificationEmailOfZone(vm.ParamZoneId)
            .then(
                function success(data) {
                    $rootScope.LastVerificationEmailSendingDateOfGuide = data.data;
                },
                function error(data) { });
    }

    $rootScope.GetLastSendingTimeOfVerificationEmailOfZone();

    function getAdminZoneTeam(zoneId, lang) {
        AdminService.getAdminZoneTeamEmpty(zoneId, lang)
            .then(function (zone) {
                vm.SearchVM.AuthorList = zone.data.AuthorList;
                vm.SearchVM.TranslatorList = zone.data.TranslatorList;
                vm.SearchVM.CorrectorList = zone.data.CorrectorList;
                $rootScope.SideBarSearchVM = vm.SearchVM;
            });
    }

   
};